import { createStore } from 'jotai'
import { createContext, ReactNode, useContext, useEffect, useMemo } from 'react'
import { TransformerState, transformerStateAtom } from './state'

export const TransformerStoreContext = createContext<ReturnType<typeof createStore> | null>(null)

export function TransformerStoreProvider(
	{
		children,
		value,
		onChange,
	}: {
		children: ReactNode
		value: TransformerState
		onChange: (state: TransformerState) => void
	},
) {
	const store = useMemo(() => createStore(), [])

	useEffect(() => {
		store.set(transformerStateAtom, value)
	}, [value, store])

	useEffect(() => {
		store.sub(transformerStateAtom, () => onChange(store.get(transformerStateAtom)))
	}, [store, onChange])

	return (
		<TransformerStoreContext.Provider value={store}>
			{children}
		</TransformerStoreContext.Provider>
	)
}

export function useTransformerStore() {
	const store = useContext(TransformerStoreContext)
	if (!store) {
		throw new Error('TransformerStoreContext not found')
	}
	return store
}
